export class PredefinedQuery {
  queryKey: number;
  queryName: string;
  queryDescription: string;
  paginated: boolean;
  variables: PredefinedQueryVariable[];
  withVariables: string;
}

export class PredefinedQueryDetail {
  queryKey: number;
  queryName: string;
  queryDescription: string;
  querySql: string;
  paginated: boolean;
}

export class PredefinedQueryVariable {
  requeteVariableKey: number;
  rang: number;
  required: boolean;
  variable: {
    variableKey: number,
    codeSubstitution: string,
    description: string,
    placeholder: string,
    type: string
    };
}

export class ColumnDefinition {
  name: string;
  type: string;
}

export class VariablesRequest {
  requeteVariableKey: number;
  name: string;
  value: string;
}

export class PredefinedQueryRequest {
  queryKey: number;
  variables: VariablesRequest[];
}

export class QueryResultatsResponse {
  columnList?: QueryResultType[];
  valueList?: any[];
  metaData?: MetaDataResponse;
}

export class QueryResultType {
  name!: string;
  type!: string;
}

export class MetaDataResponse {
  currentPage!: number;
  pageSize!: number;
  totalElements!: number;
  totalPages!: number;
}
